export const getTypeIcon = (type) => {
  const icons = {
    text: 'fa-solid fa-file-lines',
    video: 'fa-solid fa-video',
    pdf: 'fa-solid fa-file-pdf',
    link: 'fa-solid fa-link',
    quiz: 'fa-solid fa-clipboard-question',
  };
  return icons[type] || 'fa-solid fa-file';
};

export const separateEntriesByReadStatus = (entries, currentUserId, isEntryReadByUser) => {
  const unreadEntries = entries.filter((entry) => !isEntryReadByUser(entry, currentUserId));
  const readEntries = entries.filter((entry) => isEntryReadByUser(entry, currentUserId));
  return { unreadEntries, readEntries };
};
